export default __webpack_public_path__ + "static/ig_icon-d4f321ec2b5ba6944d3a3d83e41a9dbf.png";